import createIcon from '../../createIcon';

/**
 * @component @name SettingsInputComposite
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNSAyQzUgMS40NSA0LjU1IDEgNCAxQzMuNDUgMSAzIDEuNDUgMyAyVjZIMVYxMkg3VjZINVYyWk05IDE2QzkgMTcuMyA5Ljg0IDE4LjQgMTEgMTguODJWMjNIMTNWMTguODJDMTQuMTYgMTguNDEgMTUgMTcuMzEgMTUgMTZWMTRIOVYxNlpNMSAxNkMxIDE3LjMgMS44NCAxOC40IDMgMTguODJWMjNINVYxOC44MkM2LjE2IDE4LjQgNyAxNy4zIDcgMTZWMTRIMVYxNlpNMjEgNlYyQzIxIDEuNDUgMjAuNTUgMSAyMCAxQzE5LjQ1IDEgMTkgMS40NSAxOSAyVjZIMTdWMTJIMjNWNkgyMVpNMTMgMkMxMyAxLjQ1IDEyLjU1IDEgMTIgMUMxMS40NSAxIDExIDEuNDUgMTEgMlY2SDlWMTJIMTVWNkgxM1YyWk0xNyAxNkMxNyAxNy4zIDE3Ljg0IDE4LjQgMTkgMTguODJWMjNIMjFWMTguODJDMjIuMTYgMTguNDEgMjMgMTcuMzEgMjMgMTZWMTRIMTdWMTZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SettingsInputComposite = createIcon('SettingsInputComposite', [
  [
    'path',
    {
      d: 'M5 2C5 1.45 4.55 1 4 1C3.45 1 3 1.45 3 2V6H1V12H7V6H5V2ZM9 16C9 17.3 9.84 18.4 11 18.82V23H13V18.82C14.16 18.41 15 17.31 15 16V14H9V16ZM1 16C1 17.3 1.84 18.4 3 18.82V23H5V18.82C6.16 18.4 7 17.3 7 16V14H1V16ZM21 6V2C21 1.45 20.55 1 20 1C19.45 1 19 1.45 19 2V6H17V12H23V6H21ZM13 2C13 1.45 12.55 1 12 1C11.45 1 11 1.45 11 2V6H9V12H15V6H13V2ZM17 16C17 17.3 17.84 18.4 19 18.82V23H21V18.82C22.16 18.41 23 17.31 23 16V14H17V16Z',
      key: '112o11',
    },
  ],
]);

export default SettingsInputComposite;
